import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  container: {
    height: '50vh'
  },
  errorMessageContainer: {
    flex: '1 0 auto',
    display: 'flex',
    color: colors.error,
    alignItems: 'center'
  },
  errorMessageText: {
    marginTop: 1,
    marginLeft: 4
  }
}

export const useStyles = createUseStyles(style)
